import { render, staticRenderFns } from "./MemberNameplate.vue?vue&type=template&id=d9de4c7a&scoped=true"
import script from "./MemberNameplate.vue?vue&type=script&lang=js"
export * from "./MemberNameplate.vue?vue&type=script&lang=js"
import style0 from "./MemberNameplate.vue?vue&type=style&index=0&id=d9de4c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9de4c7a",
  null
  
)

export default component.exports